import { object } from '@gogame/schemas';

import PathParams from './PathParams';
import { SearchParams } from './index';

const ensureSavePathParams = (path) => {
  if (path instanceof PathParams) {
    return path;
  } else if (typeof path === 'string') {
    return new PathParams(path);
  } else {
    throw Error('Link path parameter should be a string or instance of Path');
  }
};

let i = 0;

export default class Link {
  get path() {
    return this.pathParams.path;
  }

  get absolutePath() {
    return this.pathParams.absolutePath;
  }

  constructor(pathParamsOrPath, searchParams = null) {
    if (!pathParamsOrPath) {
      throw Error(
        'Link path parameter is required, it can be a string or Path instance'
      );
    }

    this.pathParams = ensureSavePathParams(pathParamsOrPath);
    this.searchParams = searchParams || new SearchParams(object({}));
    this.key = `link_key_${i++}`;
  }

  stringify(params, options = {}) {
    const { pathname, search } = this.location(params, options);

    return `${pathname}${search}`;
  }

  location(params, options = {}) {
    // eslint-disable-next-line
    const { omitUrlParams = true, basename } = options;
    return {
      pathname: this.pathParams.stringify(params, basename),
      search: this.searchParams
        ? this.searchParams.stringify(this.pathParams.omitPathParams(params))
        : '',
      hash: '',
    };
  }

  parse({ pathname, search }) {
    const pathMatch = this.path.parse(pathname);
    if (!pathMatch) {
      return null;
    }

    return {
      ...pathMatch,
      ...this.searchParams.parse(search.slice(1)),
    };
  }

  child(path, searchParams) {
    const child = new Link(
      this.pathParams.child(path),
      searchParams || this.searchParams
    );
    child.key = this.key;
    return child;
  }

  target(target) {
    if (target) {
      this._target = target;
      return this;
    }

    return this._target;
  }
}
